import * as y from "yup"
import {ComponentBase, baseSchema} from "./base"

/** a union of all possible triggers */
export type Trigger = TriggerCelebrations
// | TriggerB

const triggers = {
  celebrations: "celebrations_recognition_nudge"
} as const

type TriggerIds = typeof triggers

interface TriggerCelebrations extends ComponentBase {
  triggerId: TriggerIds["celebrations"]
}

// NOTE: example of adding a new trigger
// interface TriggerB extends ComponentBase {
//   triggerId: TriggerIds['other']
//   other: {v: string}
// }

export const TriggerSchema = y.object<Trigger>({
  ...baseSchema,
  triggerId: y.mixed().oneOf(Object.values(triggers)).required()

  // NOTE: for someone extending these triggers, don't be tempted to try to use
  // our current version of yup to write a schema for a discrimiated union.
  // Instead it's likely best to have a unique field for each trigger and then
  // validate for a given triggerId, the approapriate field is present (do this
  // manually in javascript, not the schema)
})
